import React, { useState, useEffect } from 'react';
import '../../../css/administration.css'
import '../../../components/layout/layout.css'
import BasicCard from '../../../components/basics/cards/BasicCard'
import BasicAddEditHelpers from "../../../components/basics/tabs/add-edit/utils/BasicAddEditHelpers";
import FilterSettings from '../../../components/FilterSettings'
import Button from 'react-bootstrap/Button'
import SummaryTable from './SummaryTable'
import SimpleTable from './SimpleTable'
import './lspProfile.css'
import '../../../routes/basicreport/basicReport.css'
import { CommonAPIService } from "../../../services/apis/CommonAPIService";
function LspProfile({ pageTitle}) {
   

    const [updatingFilter, setUpdatingFilter] = useState(false)
    const [overviewData, setOverviewData] = useState([]);
    const [summaryData, setSummaryData] = useState([]);
    const [detailData, setDetailData] = useState([]);

    const [isOverviewLoading, setIsOverviewLoading] = useState(true);
    const [isSummaryLoading, setIsSummaryLoading] = useState(true);
    const [isDetailDataLoading, setIsDetailDataLoading] = useState(true);

    const basicAddEditHelpers = new BasicAddEditHelpers()


    const [pageConfig, setPageConfig] = useState({
        controllerName: "LSPProfile",
        apiName: process.env.REACT_APP_LST_API_DOMAIN + '/api/',
        parameters: "",
    });

    const handleOverviewDownloadClick = () => {
        const filterArrayString = encodeURIComponent(JSON.stringify(filterArray));

        CommonAPIService.callApiUsingUrlReturnBlob(`${pageConfig.apiName}${pageConfig.controllerName}/DownloadOverview?filterArray=${filterArrayString}`)
            .then(blob => {
                // Create a URL for the blob
                const url = URL.createObjectURL(blob);

                // Create a link element and set its href attribute to the blob URL
                const link = document.createElement('a');
                link.href = url;

                // Set the link element's download attribute to the desired file name
                link.download = 'LspProfile.xlsx';

                // Click the link to download the file
                link.click();

                // Clean up the URL and link elements
                URL.revokeObjectURL(url);
                link.remove();
            }, [pageConfig.apiName], [pageConfig.controllerName], [filterArray])
            .catch(error => console.error(error));
    };



    const handleDetailsDownloadClick = () => {
        const filterArrayString = encodeURIComponent(JSON.stringify(filterArray));

        CommonAPIService.callApiUsingUrlReturnBlob(`${pageConfig.apiName}${pageConfig.controllerName}/DownloadDetails?filterArray=${filterArrayString}`)
            .then(blob => {
                // Create a URL for the blob
                const url = URL.createObjectURL(blob);

                // Create a link element and set its href attribute to the blob URL
                const link = document.createElement('a');
                link.href = url;

                // Set the link element's download attribute to the desired file name
                link.download = 'Report result detail.xlsx';

                // Click the link to download the file
                link.click();

                // Clean up the URL and link elements
                URL.revokeObjectURL(url);
                link.remove();
            }, [pageConfig.apiName], [pageConfig.controllerName], [filterArray])
            .catch(error => console.error(error));
    };



    useEffect(() => {
        CommonAPIService.callApiUsingUrl(`${pageConfig.apiName}${pageConfig.controllerName}/PageSettings`)
            .then(data => setPageConfig({ ...pageConfig, ...{ pageSettings: data } }))
            .catch(error => console.error(error));
    }, [pageConfig.apiName, pageConfig.controllerName]);

    const [filterArray, setFilterArray] = useState(0)

    useEffect(() => {
        CommonAPIService.callApiUsingUrl(`${process.env.REACT_APP_LST_API_DOMAIN + '/api/'}${pageConfig.controllerName}/PageSettings`)
            .then(data => setPageConfig({ ...pageConfig, ...{ pageSettings: data } }))
            .catch(error => console.error(error));
    }, [pageConfig.apiName, pageConfig.controllerName]);

  

    /* Overview Data*/
    useEffect(() => {
        if (Array.isArray(filterArray)) {
            setUpdatingFilter(true)
            const filterArrayString = encodeURIComponent(JSON.stringify(filterArray));
            // fetch data from API
            setIsOverviewLoading(true);
            CommonAPIService.callApiUsingUrl(`${pageConfig.apiName}${pageConfig.controllerName}/Data?filterArray=${filterArrayString}`)
                .then(response => {
                    setOverviewData(response);
                    setUpdatingFilter(false)
                    setIsOverviewLoading(false);
                })
        }
    }, [pageConfig.apiName, pageConfig.controllerName, filterArray]);

    /* Survival Period */
    useEffect(() => {
        if (Array.isArray(filterArray)) {
            setUpdatingFilter(true)
            const filterArrayString = encodeURIComponent(JSON.stringify(filterArray));
            // fetch data from API
            setIsSummaryLoading(true);
            CommonAPIService.callApiUsingUrl(`${pageConfig.apiName}${pageConfig.controllerName}/DataLSPProfileSurvivalPeriod?filterArray=${filterArrayString}`)
                .then(response => {
                    setSummaryData(response);
            setUpdatingFilter(false)
                    setIsSummaryLoading(false);

                })
        }
    }, [pageConfig.apiName, pageConfig.controllerName, filterArray]);

    /* Detail Data */
    useEffect(() => {
        if (Array.isArray(filterArray)) {
            setUpdatingFilter(true)
            const filterArrayString = encodeURIComponent(JSON.stringify(filterArray));
            // fetch data from API
            setIsDetailDataLoading(true);
            CommonAPIService.callApiUsingUrl(`${pageConfig.apiName}${pageConfig.controllerName}/DataDetails?filterArray=${filterArrayString}`)
                .then(response => {
                    setDetailData(response);
                    setUpdatingFilter(false)
                    setIsDetailDataLoading(false);

                })
        }
    }, [pageConfig.apiName, pageConfig.controllerName, filterArray]);




    return (
        <BasicCard cardConfig={{ cardTitle: pageTitle, cardHeadingElement: 'h3' }}>
            <span className='basic-report-card'>
                <FilterSettings pageConfig={pageConfig} filterArray={filterArray} setFilterArray={setFilterArray} updatingFilter={updatingFilter} />               
                <BasicCard  cardConfig={{ cardTitle: 'Report results overview', cardHeadingElement: 'h5' }}>
              
                  
                    {!isOverviewLoading &&  (
                    <div className='listing-table-wrapper'>
                        {/* Overview Data*/}
                            <SimpleTable tableConfig={basicAddEditHelpers.createTableConfigDataResonseModel(overviewData)}  /> 
                    </div>
                    )}
                   <br></br>
                    {!isSummaryLoading && (
                        <div className='listing-table-wrapper'>
                            {/* Overview Data*/}
                            <SummaryTable tableConfig={basicAddEditHelpers.createTableConfigDataResonseModel(summaryData)} />
                        </div>
                    )}

                    
                    <span className='brd-download-items'>
                        <Button variant='primary' onClick={handleOverviewDownloadClick}>
                            Download Overview
                        </Button>
                    </span>
                </BasicCard>
                <BasicCard cardConfig={{ cardTitle: 'Report result details', cardHeadingElement: 'h5' }}>
                {!isDetailDataLoading  && (
                    <div className='listing-table-wrapper'>
                            <SimpleTable tableConfig={basicAddEditHelpers.createTableConfigDataResonseModel(detailData)} />
                    </div>
                )}
                    <span className='brd-download-items'>
                        <Button variant='primary' onClick={handleDetailsDownloadClick}>
                            Download Details
                        </Button>
                    </span>
                </BasicCard>
            </span>
        </BasicCard>




    )
}

export default LspProfile